export { Body1Stronger } from './Body1Stronger';
export { body1StrongerClassNames } from './useBody1StrongerStyles.styles';
